import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import { Button } from '@mui/material'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const AcknowledgementsModal = ({
  handleAcknowledgementsModal,
  modalOpen = false,
}) => {
  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleAcknowledgementsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="acknowledgements-modal">
          <h3 className="fs-24 mb-3 fw-bold">Acknowledgements</h3>
          <div className="text-left">
            <p className="fs-16 font-weight-bold mb-1">Acknowledgements</p>
            <p className="fs-14">
              Etiam convallis elementum sapien, a aliquam turpis aliquam vitae.
              Praesent sollicitudin felis vel mi facilisis posuere. Pellentesque
              habitant morbi tristique senectus et netus et malesuada fames ac
              turpis egestas. Curabitur dignissim massa nec libero scelerisque
              rutrum. Curabitur ac purus id elit hendrerit lacinia. Nullam sit
              amet sem efficitur, porta diam in, convallis tortor. Etiam
              convallis elementum sapien, a aliquam turpis aliquam vitae.
              Praesent sollicitudin felis vel mi facilisis posuere. Nulla
              ultrices facilisis justo, non varius nisl semper vel. Interdum et
              malesuada fames ac ante ipsum primis in faucibus. Phasellus at
              ante mattis, condimentum velit et, dignissim nunc. Integer quis
              tincidunt purus. Duis dignissim mauris vel elit commodo, eu
              hendrerit leo ultrices. Nulla vehicula vestibulum purus at rutrum.
            </p>
            <Button
              disableElevation
              fullWidth
              className="pointer mt-5"
              onClick={() => handleAcknowledgementsModal(false)}
              id="btn-primary-no-shadow"
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default AcknowledgementsModal
